import { Modal, ModalWidth } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const t = translationKeys.mainMenuTileItem.consentModal;

type AiAssistantMainMenuTileItemConsentModalProps = { onConfirm: VoidFunction; onClose: VoidFunction };

export const AiAssistantMainMenuTileItemConsentModal = (
   props: AiAssistantMainMenuTileItemConsentModalProps
): JSX.Element => (
   <Modal
      testId={'recordingConsent'}
      title={t.title}
      onCancel={props.onClose}
      onCloseRequest={props.onClose}
      onConfirm={props.onConfirm}
      confirmationButtonLabel={t.confirm}
      cancelButtonLabel={t.cancel}
      width={ModalWidth.NORMAL}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
   >
      <Translate>{t.message}</Translate>
   </Modal>
);
